import { call } from 'redux-saga/effects';
import * as Api from '../../../services/fbm-api';
import * as routines from './routines';
import { sagaRoutineRequest } from '../../../helpers/saga';

export const fetchCustomList = ({ payload: { type } }) =>
  sagaRoutineRequest(routines.fetchCustomList, {
    request: () => call(Api.fetchCustomList, { type })
  });
